<template>
  <div class="w-full flex items-center bg-white">
    <input
      v-model="text"
      type="text"
      placeholder="Type..."
      @keyup.enter="sendText"
      class="w-full outline-none bg-white"
    />
    <button
      class="bg-white hover:bg-white text-gray-700 font-semibold capitalize"
      @click="sendText"
    >
      <Icon icon="fluent:send-32-regular" width="24" height="24" />
    </button>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Icon } from "@iconify/vue";
import { updateParticipant } from "../api/userRequests";
import useChatbotStore from "../store/chatbot";

export default {
  components: { Icon },
  props: {
    // speechText: {
    //   type: String,
    //   default: "",
    // },
  },
  data() {
    return {
      text: "",
      chatStore: useChatbotStore(), // Use the store in the data option
    };
  },
  watch: {
    // speechText(newText) {
    //   this.text = this.text + " " + newText; // Update localText when the prop changes
    // },
  },
  methods: {
    async sendText() {
      if (this.chatStore.isLastTry) {
        await this.manageUserDetails(this.text.trim());
        return;
      }
      if (this.text.trim()) {
        this.$emit("sendMessage", this.text);
        this.text = "";
      }
    },
    async manageUserDetails(email) {
      if (this.chatStore.isLastUserTry && !this.chatStore.user?.email) {
        if (!email) {
          Swal.fire({ icon: "error", title: "Enter Email to use bot further" });
          return;
        }
        // Basic email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          Swal.fire({
            icon: "error",
            title: "Please enter a valid email address.",
          });
          return;
        }

        try {
          this.$emit("clearSpeakingStatus");

          console.log("api call test: ", {
            email: email,
            clientId: this?.chatStore?.user?.clientId,
          });

          const response = await updateParticipant(this.chatStore?.user?._id, {
            email: email,
            clientId: this?.chatStore?.user?.clientId,
            videoId: this?.chatStore?.videoDetails?.id,
          });

          console.log("res", response);

          if (!response?.data?.data) return;

          this.chatStore?.setUser(response?.data?.data);
          localStorage.setItem(
            "participant",
            JSON.stringify(response?.data?.data)
          );

          this.chatStore.setMessage({
            sender: "user",
            text: email,
            type: "text",
          });
          this.chatStore.setMessage({
            sender: "bot",
            text: "Thank you for providing your email! You can now continue using the bot.",
            type: "text",
          });
          this.text = "";
        } catch (error) {
          console.error("Update User API call error:", error);
        }
      }
    },
  },
};
</script>

<style scoped>
input {
  flex: 1;
  padding: 8px;
}

button {
  padding: 8px 12px;
}

@media (max-width: 768px) {
  button {
    font-size: 14px;
  }
}
</style>
